import { createContext, Context, useState, ReactNode } from "react";

import Run from "../types/run";
import { sortRuns } from "../utils/utils";

export enum RunMethods { 
  addRun = 'addRun',
  updateRun = 'updateRun'
};

export type RunContextType = {
  runs: Run[],
  totalRuns: number,
  setRuns?: (runs: Run[]) => void
  addRun?: (run: Run) => void
  updateRun?: (run: Run) => void
  removeRun?: (run: Run) => void
};

const RunsContext: Context<RunContextType> = createContext({
  runs: [] as Run[],
  totalRuns: 0
});

export function RunsContextProvider({ children }: { children: ReactNode }) {
  const [runs, setRuns] = useState<Run[]>([] as Run[]);

  function setRunsHandler(runs: Run[]) {
    runs.sort(sortRuns);
    setRuns(runs);
  };

  function addRunHandler(run: Run) {
    setRuns((preRuns: Run[]) => preRuns.concat(run));
  };

  function updateRunHandler(runToUpdate: Run) {
    setRuns((preRuns: Run[]) => {
      const runs = [] as Run[];
      preRuns.forEach(run => {
        if(run._id === runToUpdate._id) {
          runs.push(runToUpdate);
        } else {
          runs.push(run);
        }
      })
      return runs;
    });
  };

  function removeRunHandler(runToRemove: Run) {
    setRuns((preRuns: Run[]) => {
      const runs = [] as Run[];
      preRuns.forEach(run => {
        if(run._id !== runToRemove._id) {
          runs.push(run);
        }
      })
      return runs;
    });
  };

  const context: RunContextType = {
    runs: runs,
    totalRuns: runs ? runs.length : 0,
    setRuns: setRunsHandler,
    addRun: addRunHandler,
    removeRun: removeRunHandler,
    updateRun: updateRunHandler
  };

  return (
    <RunsContext.Provider value={context}>
      {children}
    </RunsContext.Provider>
  );
};

export default RunsContext;
